export default "__VITE_ASSET__DxbA8_o5__"